import { listMyProfiles } from '@/api/auth';
import { ssoCheckLoginStatus } from '@/api/auth/sso';
import api from '@/api';
import { roles } from '@/data/constants';

const state = {
  allowedRoles: [roles.admin, roles.clinicStaff], //[Check] vary by projects
  mustLogin: true,
  user: null,
  profile: null,
  profiles: [],
  currentClinic: null,
  /** @type {Boolean | Error} */
  loginBlocked: false,
};

const mutations = {
  setUser(state, user) {
    state.user = user;
  },
  setProfile(state, profile) {
    state.profile = profile;
  },
  setProfiles(state, profiles) {
    state.profiles = Array.isArray(profiles) ? profiles : [];
  },
  setLoginBlocked(state, blocked) {
    state.loginBlocked = blocked;
  },
  setCurrentClinic(state, clinic) {
    state.currentClinic = clinic;
  },
};

const actions = {
  async checkLoginStatus({ commit, state, dispatch }) {
    try {
      const data = await ssoCheckLoginStatus(api);
      commit('setUser', data.user);
      commit('setProfile', data.profile);
      if (!data.user && state.mustLogin) {
        throw new Error('mustLogin');
      }
      if (data.profile && !state.allowedRoles.includes(data.profile.role)) {
        throw new Error('allowedRoles');
      }
      if (data.profile.enabled !== true) {
        await dispatch('logout');
        throw new Error('Account Disabled');
      }
      // Temporarily not used in the project, comment to avoid fetching errors
      // try {
      //   if (data.user && data.profile.role !== roles.master) {
      //     commit('setProfiles', (await listMyProfiles(api, { limit: 50 })).docs);
      //   } else {
      //     commit('setProfiles', []);
      //   }
      // } catch (e) {
      //   commit('setProfiles', []);
      //   // console.log(e);
      // }
      return data;
    } catch (e) {
      throw e;
    }
  },
  async logout({ commit }) {
    commit('setUser', null);
    commit('setProfile', null);
    commit('setProfiles', []);
    commit('setCurrentClinic', null);
  },
  setClinic({ commit }, clinic) {
    commit('setCurrentClinic', clinic);
  },
};

const getters = {
  user: state => state.user,
  profile: state => state.profile,
  profiles: state => state.profiles,
  userId: state => state.user && state.user._id,
  profileId: state => state.profile && state.profile._id,
  role: state => state.profile && state.profile.role,
  isAdmin: (state, getters) => getters.role === roles.admin,
  isClinicStaff: (state, getters) => getters.role === roles.clinicStaff,
  clinicId: state => state.profile && state.profile.clinic,
  isLoggedIn: state => !!state.user,
  loginBlocked: state => state.loginBlocked,
  currentClinic: state => state.currentClinic,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
